import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=0a3a0da8&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3a0da8')) {
      api.createRecord('0a3a0da8', component.options)
    } else {
      api.reload('0a3a0da8', component.options)
    }
    module.hot.accept("./ForgottenPassword.vue?vue&type=template&id=0a3a0da8&", function () {
      api.rerender('0a3a0da8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ForgottenPassword.vue"
export default component.exports